import MyExpApi from "../../enum/MyExpApi";
import ApiPurchaseOrder from "../../../../shared/model/ApiPurchaseOrder";
import ApiPurchaseOrderRequest from "../../../../shared/types/ApiPurchaseOrderRequest";
import ContextEntityType from "../../../../shared/enums/ContextEntityType";
import ContextType from "../../../../shared/enums/ContextType";
import { ApiPurchaseOrderSummaryRequest } from "../../../../shared/types/ApiPurchaseOrderSummaryRequest";
import { successToast } from "../../../../shared/utils/toastNotification";
import { useCopies } from "../../../../shared/hooks/useCopies";
import { HttpVerb } from "../../../../shared/utils/enums";
import { useGetApiData, useGetApiDataAsMutate, usePostApiData } from "../../../../shared/datalayer";

export function useGetPurchaseHistoryList(registrationParticipantId: string) {
  const paramsReqObj: ApiPurchaseOrderRequest = {
    contextEntityType: ContextEntityType.PARTICIPANT,
    contextType: ContextType.REGISTRATION,
    entityId: registrationParticipantId,
    registrationParticipantId: registrationParticipantId
  };
  return useGetApiData<Array<ApiPurchaseOrder>>(
    MyExpApi.PURCHASE_ORDER_LIST,
    { method: HttpVerb.POST, body: paramsReqObj },
    {
      enabled: Boolean(registrationParticipantId)
    }
  );
}

export function useSendPurchaseOrderSummary() {
  const copies = useCopies();
  return usePostApiData<void, ApiPurchaseOrderSummaryRequest>(MyExpApi.SEND_PURCHASE_ORDER_SUMMARY, {
    onSuccess: data => {
      successToast(copies.get("email.sent"));
    }
  });
}

export function useDownloadPurchaseOrderInvoice() {
  const copies = useCopies();
  return useGetApiDataAsMutate<any>(MyExpApi.DOWNLOAD_PURCHASE_ORDER, {
    onSuccess: () => {
      successToast(copies.get("purchase.history.invoice.download.success"));
    }
  });
}
